/**
 * Главный API Service
 * Объединяет все API методы
 */

import { createApiClient, ApiConfig } from './config';
import { ChatApiService } from './chat.api';
import { FilesApiService } from './files.api';

/**
 * Главный класс API Service
 */
export class ApiService {
  /** Chat API методы */
  public chat: ChatApiService;
  
  /** Files API методы */
  public files: FilesApiService;

  constructor(config: ApiConfig) {
    // Создаем Axios client
    const client = createApiClient(config);

    // Инициализируем сервисы
    this.chat = new ChatApiService(client);
    this.files = new FilesApiService(client);
  }
}

/**
 * Экспорт типов и классов
 */
export * from './config';
export * from './chat.api';
export * from './files.api';

